import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-find-templates',
  templateUrl: './find-templates.component.html',
  styleUrls: ['./find-templates.component.scss']
})
export class FindTemplatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
